export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M4 20h16V4H4zM4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m2.91 5.41L11.5 12l-4.59 4.6-1.41-1.42L8.68 12 5.5 8.82zM13 13h5v2h-5z\"/>"
};